import React from 'react';

/**
 * M3 §5.3. The five `!` overrides this replaces did NOT pin a dialog bottom-left:
 * tailwind-merge folds the important flag into its dedup key, so `!left-[1%]` and
 * Dialog.tsx:90's base `left-[50%]` landed in different buckets and both shipped, and
 * `top`/`bottom` are separate conflict groups so `!bottom-[3%]` could not cancel
 * `top-[50%]`. Measured live in a 1400x900 window: top:450px, left:14px. develop pinned
 * both of the fork's dialogs that way (OrganReviewDialog.tsx:59-64).
 *
 * An inline style is the mechanism, not ManagedDialog's `defaultPosition` — that prop
 * exists only on ManagedDialogProps, reachable only through uiDialogService, which both
 * consumers deliberately bypass. DialogContent forwards `style` untouched when not
 * draggable (Dialog.tsx:95, :102).
 *
 * `animation` and `transition` are switched off for the same reason ManagedDialog does it
 * at :138-139 (its style object runs :130-141): the base class list carries `data-[state=open]:animate-in
 * slide-in-from-left-1/2 slide-in-from-top-[48%]`, whose keyframes set `transform` and so
 * override the inline one for the duration of the entrance.
 */
export const ANCHOR: React.CSSProperties = {
  position: 'fixed',
  left: '1%',
  top: 'auto',
  bottom: '3%',
  transform: 'translate(0, 0)',
  margin: 0,
  animation: 'none',
  transition: 'none',
};
